import { useCallback, useState } from 'react'

export type ToastType = 'success' | 'error' | 'info'

export type ToastData = {
  id: string
  message: string
  type: ToastType
  duration?: number
}

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastData[]>([])

  const showToast = useCallback(
    (message: string, type: ToastType = 'success', duration: number = 3000) => {
      const id = Date.now().toString()
      const newToast: ToastData = {
        id,
        message,
        type,
        duration,
      }

      setToasts((prev) => [...prev, newToast])

      return id
    },
    [],
  )

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  const showSuccess = useCallback(
    (message: string, duration?: number) => {
      return showToast(message, 'success', duration)
    },
    [showToast],
  )

  const showError = useCallback(
    (message: string, duration?: number) => {
      return showToast(message, 'error', duration)
    },
    [showToast],
  )

  const showInfo = useCallback(
    (message: string, duration?: number) => {
      return showToast(message, 'info', duration)
    },
    [showToast],
  )

  return {
    toasts,
    showToast,
    showSuccess,
    showError,
    showInfo,
    removeToast,
  }
}
